/** Inicio de la semana (lunes 00:00 local), en ms. */
export function getWeekStartMs(d = new Date()): number {
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  const mon = new Date(d);
  mon.setDate(diff);
  mon.setHours(0, 0, 0, 0);
  return mon.getTime();
}

/** Inicio del mes calendario local, en ms. */
export function getMonthStartMs(d = new Date()): number {
  return new Date(d.getFullYear(), d.getMonth(), 1).getTime();
}
